import createDecorator from 'final-form-focus'
import PropTypes from 'prop-types'
import React, { useRef, useState } from 'react'
import Cookies from 'js-cookie'
import { Form, FormSpy, Field } from 'react-final-form'


import { gtmFirstInteraction } from 'utils/client/analitics'
import { scrollToErrorInput } from 'utils/client/scroll'
import {
  composeValidators,
  errorFromDict,
  errorCustom,
  minLength,
  required,
  isEmail,
} from 'forms/validations'
import { LocalizationContext } from 'contexts/Localization'
import { RU } from 'constants/countries'
import { phoneMaskEurope, phoneMaskRussian } from 'forms/masks'

import Checkbox from 'components/_form/Checkbox'
import PhoneField from 'components/_form/PhoneField'
import TextField from 'components/_form/TextField'
import YandexMapModal from 'components/_form/YandexDelivery'
import AddressLine from 'components/_form/AddressLine'
import RadioButton from 'components/_form/RadioButton'
import CheckboxTermsRu from 'components/_special/CheckboxTermsRu'
import ButtonRounded from 'components/ButtonRounded/ButtonRounded'
import usePersInfoSubmit from '../hooks/usePersInfoSubmit'

import {
  ConsentBlock,
  ConsentIntro,
  ConsentRow,
  ContactField,
  ContactGrid,
  DeliveryAddress,
  DeliveryButtonWrap,
  DeliveryChoice,
  DeliveryRow,
  FieldHint,
  H4Styled,
  PaymentRow,
  PaymentStack,
  PhoneFieldWrap,
  TextLHStyled,
} from './styles'
import './DeliveryMapButton.scss'

// Indent for info icon place to call tooltip with hint
// const MOBILE_SELECT_RIGHT_INDENT = 40

const focusOnError = createDecorator(undefined, scrollToErrorInput)
const DELIVERY_BUTTON_LABEL = 'Выбрать пункт выдачи'
const DELIVERY_BUTTON_LABEL_CHANGE = 'Выбрать другой пункт выдачи'

const OrderPersInfoRuForm = React.forwardRef((props, ref) => {
  const {
    onChange,
    onSubmit,
    id,
    errorsDict,
    initialValues,
    texts,
    isDisabled,
  } = props
//   const collapsedFields = React.useRef(null)
  const formRef = useRef(null);
  const [initVal] = React.useState(() => initialValues)
  const [isMapOpen, setMapOpen] = React.useState(() => false)
  const [selectedAddress, setSelectedAddress] = useState(
    () => Boolean(initialValues?.address?.id || initialValues?.address?.full_address),
  )
  const {
    dict,
    locale,
    currentCountry: { alpha2Code },
  } = React.useContext(LocalizationContext)

  /*
   * Memorize validations
   */

//   const formValidation = React.useCallback(
//     values => {
//       if (
//         deliveryType === DELIVERY_TYPES.courier &&
//         (!values.postcode || !values.house)
//       ) {
//         if (addressIsSelected.current && !gtmErrorIsSend.current) {
//           gtmEvent({
//             event: 'Fill - Address —  Error',
//             description: `Not found postcode or house (address: ${values.address}, postcode: ${values.postcode}, house: ${values.house})`,
//           })
//           gtmErrorIsSend.current = true
//         }
//         return {
//           address: dict.errors.address_required,
//         }
//       }

//       if (addressIsSelected.current && !gtmSuccessIsSend.current) {
//         gtmEvent({ event: 'Fill - Address —  Success' })
//         gtmSuccessIsSend.current = true
//       }
//     },
//     [deliveryType, dict.errors.address_required],
//   )

  /*
   * Handle animation for delivery switch
   */
//   useDeliveryTypeAnimation({ dropdownRef: ref, collapsedFields, deliveryType })

  const onPersInfoSubmit = usePersInfoSubmit({ onChange, onSubmit })

  const errorCustomOffer = (cstmError, validation) => value => {
    const error = validation(value)
    return error && cstmError ? ' ' : undefined
  }

  const [FirstInterectionGTMEventSent, SetFirstInterectionGTMEventSent] = useState(false)
  const handleOnFocus = () => {
    if (!FirstInterectionGTMEventSent) {
      gtmFirstInteraction()
      SetFirstInterectionGTMEventSent(true)
    }
  }

  const csrfToken = Cookies.get('XSRF-TOKEN') // Make sure the name matches the cookie name set by your server

  const handleAddressSelect = (addressData) => {
    if (addressData && formRef.current) {
      const normalizedAddress = {
        id: addressData.id,
        country: addressData.address.country,
        locality: addressData.address.locality,
        street: addressData.address.street,
        house: addressData.address.house,
        full_address: addressData.address.full_address,
        comment: addressData.address.comment,
      }

      // Mark the hidden field as interacted with so submit/validation state
      // stays consistent after choosing a pickup point in the modal.
      formRef.current.change('address', {
        ...normalizedAddress,
      })
      formRef.current.focus('address')
      formRef.current.blur('address')

      setSelectedAddress(true)
    }

    setMapOpen(false)
  }

  const addressRequired = value => {
    if (!value?.id) return errorsDict.contact_details_required
  }

  return (
    <>
      <Form
        onSubmit={onPersInfoSubmit}
        decorators={[focusOnError]}
        initialValues={initVal}
        // validate={formValidation}
        render={({ handleSubmit, submitting, form }) => {

          formRef.current = form

          return (
            <form id={id} ref={ref} onSubmit={handleSubmit} noValidate={true}>
              <H4Styled>
                Данные получателя
              </H4Styled>
              <ContactGrid>
                <ContactField>
                  <TextField
                    autoComplete='name'
                    placeholder={texts.fields.name.title}
                    name='name'
                    isDisabled={isDisabled}
                    withoutErrorIndent={true}
                    validate={errorCustom(
                      errorsDict.contact_details_required,
                      required,
                    )}
                    onFocus={handleOnFocus}
                  />
                </ContactField>

                <ContactField>
                  <TextField
                    autoComplete='email'
                    placeholder={texts.fields.email.title}
                    type='email'
                    name='email'
                    isDisabled={isDisabled}
                    withoutErrorIndent={true}
                    validate={composeValidators([
                      errorCustom(errorsDict.email_required, required),
                      errorFromDict(errorsDict, isEmail),
                    ])}
                  />
                  <FieldHint>*На эту почту придёт информация о заказе</FieldHint>
                </ContactField>

              <Field
                name='_csrf' // The name should match what your server expects
                component='input'
                type='hidden'
                initialValue={csrfToken} // Set the CSRF token as the value
              />
              <Field
                name='phone_code'
                component='input'
                type='hidden'
              />
                <PhoneFieldWrap>
                  <PhoneField
                    autoComplete='tel'
                    placeholder={texts.fields.phone.title}
                    isDisabled={isDisabled}
                    type='tel'
                    name='phone'
                    withoutErrorIndent={true}
                    phoneMask={locale === RU ? phoneMaskRussian : phoneMaskEurope}
                    alpha2Code={alpha2Code}
                    validate={composeValidators([
                      errorCustom(errorsDict.contact_details_required, required),
                      errorCustom(
                        errorsDict.phone_min_length,
                        minLength(locale === RU ? phoneMaskRussian.length : 5),
                      ),
                    ])}
                  />
                </PhoneFieldWrap>
              </ContactGrid>
              <H4Styled>
                Доставка
              </H4Styled>
              <DeliveryRow>
                <DeliveryChoice>
                  <RadioButton name='deliveryType'
                               label='Яндекс Доставка'
                               value='yandex'
                               iconHeight={'18px'}
                               icons={[{ id: 'delivery_yandex', width: '88px' }]} />
                  <DeliveryAddress>
                    <AddressLine
                      name='address'
                      validate={addressRequired}
                    />
                  </DeliveryAddress>
                </DeliveryChoice>
                <DeliveryButtonWrap>
                  <ButtonRounded
                    className='delivery-map-button'
                    bgClassName='bg--transp bg--border-gray'
                    blackoutClassName='bg--purple'
                    textClassName='text'
                    as='button'
                    wrapperProps={{
                      type: 'button',
                      onClick: () => setMapOpen(true),
                    }}
                  >
                    {selectedAddress ? DELIVERY_BUTTON_LABEL_CHANGE : DELIVERY_BUTTON_LABEL}
                  </ButtonRounded>
                </DeliveryButtonWrap>
              </DeliveryRow>

              <H4Styled>
                Способы оплаты
              </H4Styled>
              <PaymentStack>
                <PaymentRow>
                  <RadioButton name='payType'
                               label='Банковской картой'
                               value='card'
                               iconHeight={'24px'}
                               icons={[
                                 { id: 'pay_sber', width: '48px' },
                                 { id: 'pay_sbp', width: '41.3328px' },
                                 { id: 'pay_tinkoff', width: '54px' },
                                 { id: 'pay_dolyami', width: '72px' },
                               ]}
                  />
                </PaymentRow>
                <PaymentRow>
                  <RadioButton name='payType'
                               label='Яндекс Пэй и Сплит'
                               value='split'
                               iconHeight={'18px'}
                               icons={[
                                 { id: 'pay_split', width: '86px' },
                                 { id: 'pay_ya', width: '54px' },
                               ]}
                  />
                </PaymentRow>
              </PaymentStack>

              <ConsentBlock>
                <ConsentIntro>
                    <CheckboxTermsRu
                      locale={locale}
                      withArrow={false}
                      agreementText={texts.fields.agreement.title}
                      privacy={dict.links.privacy}
                      privacyText={texts.fields.agreement.privacy}
                    />
                </ConsentIntro>
                <ConsentRow>
                  <Checkbox
                    name='is_offer_accepted'
                    isDisabled={isDisabled}
                    isFilled={true}
                    size='base'
                    label={
                      <CheckboxTermsRu
                        locale={locale}
                        agreementText={texts.fields.agreement.offer}
                        terms='https://atlas.ru/terms'
                        termsText={texts.fields.agreement.offer_terms}
                      />
                    }
                    validate={errorCustomOffer(
                      errorsDict.have_to_agree,
                      required,
                    )}
                  />
                </ConsentRow>

                <ConsentRow className='consent-row--centered'>
                  <Checkbox
                    name='is_marketing_accepted'
                    isDisabled={isDisabled}
                    isFilled={true}
                    size='base'
                    label={
                      <TextLHStyled
                        dangerouslySetInnerHTML={{
                          __html: texts.fields.agreement.marketing,
                        }}
                      />
                    }
                  />
                </ConsentRow>

                <ConsentRow>
                  <Checkbox
                    name='is_research_accepted'
                    isDisabled={isDisabled}
                    isFilled={true}
                    size='base'
                    label={
                      <TextLHStyled
                        dangerouslySetInnerHTML={{
                          __html: texts.fields.agreement.research,
                        }}
                      />
                    }
                  />
                </ConsentRow>
              </ConsentBlock>

              <Field
                name='submit'
                type='submit'
                component='input'
                hidden={true}
                disabled={submitting || isDisabled}
              />

              <FormSpy
                subscription={{
                  values: true,
                  invalid: true,
                  active: true,
                  touched: true,
                  errors: true,
                }}
                onChange={({ values, invalid, active, touched, errors }) =>
                  onChange({ values, invalid, active, touched, errors })
                }
              />
            </form>
          )
        }}
      />

      {isMapOpen && <YandexMapModal
        onClose={handleAddressSelect}
      />}
    </>
  )
})

OrderPersInfoRuForm.propTypes = {
  errorsDict: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  initialValues: PropTypes.object.isRequired,
  optionsCountry: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  optionsPhoneCode: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  texts: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  beforeCardContent: PropTypes.node,
  isDisabled: PropTypes.bool,
  deliveryType: PropTypes.number,
  isSpecialPromotion: PropTypes.bool,
}

OrderPersInfoRuForm.defaultProps = {
  isDisabled: false,
  isSpecialPromotion: false,
}

export default OrderPersInfoRuForm
